import React from 'react'

export function ProfilePage() {
  return <div>Profile</div>
}
